import React, { memo } from 'react'
import {
  formatCurrencyValue,
  isValidPositiveNumber
} from 'src/libs/qb-brand-web-components'

import ExchangeCalculator from '../exchangePoints/ExchangeCalculator'
import BuyPointsProviderIcon from './BuyPointsProviderIcon'
import { calculateMinMaxPoints } from '../../util/pointsExchange.helpers'
import {
  BUY_POINTS_PROVIDER,
  QB_FEE_BUY_POINTS
} from '../../constants/pointsExchange'

const BuyPointsCalculator = ({
  provider,
  tokenProfile: { symbol, onramp },
  t,
  exchangeProviderProfile,
  ...restProps
}) => {
  const pointsAmount = exchangeProviderProfile.pointsAmount
  const targetProviderSymbol = provider.symbol || ''
  const checkValidPositiveNumber = isValidPositiveNumber(pointsAmount)
  const { minPoints, maxPoints } = calculateMinMaxPoints(provider, onramp)
  return (
    <ExchangeCalculator
      t={t}
      minPoints={minPoints}
      maxPoints={maxPoints}
      description={provider.description}
      icon={<BuyPointsProviderIcon {...provider} small />}
      submitLabel='buy-points.buy-points'
      exchangeValue={
        checkValidPositiveNumber
          ? formatCurrencyValue(
              provider.id === BUY_POINTS_PROVIDER.CREDIT_CARD.id
                ? pointsAmount * onramp * (1 + QB_FEE_BUY_POINTS)
                : Math.ceil((pointsAmount * onramp) / provider.offramp),
              2
            )
          : 0
      }
      exchangeLabel={targetProviderSymbol}
      exchangeProviderProfile={exchangeProviderProfile}
      maxLength={String(maxPoints).length}
      noExchangeRate
      symbol={symbol}
      {...restProps}
    />
  )
}

export default memo(BuyPointsCalculator)
